import { render, staticRenderFns } from "./SensorAction.vue?vue&type=template&id=f36d53d2&scoped=true&lang=pug&"
import script from "./SensorAction.vue?vue&type=script&lang=ts&"
export * from "./SensorAction.vue?vue&type=script&lang=ts&"
import style0 from "./SensorAction.vue?vue&type=style&index=0&id=f36d53d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36d53d2",
  null
  
)

export default component.exports